import {
  CreateTransactionResponseData,
  ValidateTransactionResponse,
} from "@ac-expo/api-types";
import { cn } from "@ui/utils";
import { navigateToPaymentIframe } from "@web-app/src/components/Cart/utils";
import { Dispatch, SetStateAction, useEffect, useRef } from "react";
import { STEPS } from "./EmbedTicketing";
import { EmbedPayOnSiteLink } from "./EmbedPayOnSiteLink";

export const IFRAME_CLOSE_EVENT_ID = "close-iframe";
export const IFRAME_USER = "user-iframe";
const IFRAME_TITLE = "paymentIframe";

type EmbedPaymentComponentProps = {
  setStep: (step: STEPS) => void;
  paymentLink: CreateTransactionResponseData | null;
  setPaymentLink: Dispatch<
    SetStateAction<CreateTransactionResponseData | null>
  >;
  setResult: Dispatch<SetStateAction<ValidateTransactionResponse | null>>;
  eventSlug: string | null;
};

function EmbedPaymentComponent({
  setStep,
  paymentLink,
  setPaymentLink,
  setResult,
  eventSlug,
}: EmbedPaymentComponentProps) {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    if (paymentLink !== null) {
      navigateToPaymentIframe(paymentLink);
    }
  }, [paymentLink, setStep]);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      /* Information received from the iframe children */
      const eventData = event.data;

      if (IFRAME_CLOSE_EVENT_ID in eventData) {
        if ("data" in eventData) {
          setResult(eventData.data);
        }
        setPaymentLink(null);
        setStep("CONFIRMATION");
      } else if (IFRAME_USER in eventData) {
        /* Which means payment is done and it's redirecting the user to the app */
        const iframe = iframeRef.current;
        if (iframe) {
          iframe.contentWindow?.postMessage(
            {
              [IFRAME_USER]: true,
              data: {},
            },
            window.location.origin
          );
        }
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [setPaymentLink, setResult, setStep]);
  return (
    <div className="flex flex-col gap-2">
      {paymentLink !== null && <EmbedPayOnSiteLink eventSlug={eventSlug} />}
      <iframe
        ref={iframeRef}
        // Up2Pay's card form and 3DS challenge must fit without a nested scroll inside the embed
        className={cn("hidden min-h-[1000px] md:min-h-[800px]", {
          "!block": paymentLink !== null,
        })}
        name={IFRAME_TITLE}
        title={IFRAME_TITLE}
      />
    </div>
  );
}

export default EmbedPaymentComponent;
